import { render } from "./ScreenModal.vue?vue&type=template&id=230096a8&scoped=true"
import script from "./ScreenModal.vue?vue&type=script&lang=js"
export * from "./ScreenModal.vue?vue&type=script&lang=js"

import "./ScreenModal.vue?vue&type=style&index=0&id=230096a8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-230096a8"]])

export default __exports__